export default function getLignesCommandesWithReferenceEcheancier(
  lignesCommande, referenceEcheancier,
) {
  let lignes = [];
  lignesCommande.forEach((ligne) => {
    if (ligne.referenceEcheancier === referenceEcheancier) lignes.push(ligne);
    if (ligne.lignesCommande) {
      const lignesEnfantFind = ligne.lignesCommande.filter((ligneEnfant) => {
        return ligneEnfant.referenceEcheancier === referenceEcheancier;
      });
      lignesEnfantFind.forEach((ligneEnfant) => { ligneEnfant.dateDebut = ligne.dateDebut; });
      lignes = lignes.concat(lignesEnfantFind);
    }
  });
  return lignes;
}
